var ppw_events_for_month = null;

(function($) {

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/

$(document).ready(function(){
    function get_events_for_month(year, month) {
        $.ajax({
            type: "POST",
            dataType: "json",
            url: acfmaps.ajaxurl,
            data: {
                action: "events_month",
                year: year,
                month: month
            },
            success: function(data){
                ppw_events_for_month = data;
                $(".ppw-calendar").datepicker("refresh");
            }

        });
    }

    function toDateString(date) {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        return [year, (month > 9 ? '' : '0') + month, (day > 9 ? '' : '0') + day].join('');
    }

    $(".ppw-calendar").datepicker({dateFormat: "yymmdd",
        onSelect: function (date, picker) {
            ppw_date_start = date;
            if (ppw_filter_changed !== null) {
                ppw_filter_changed();
                picker.input.datepicker("refresh");
            }
        },
        dayNamesMin: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
        monthNames: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
        monthNamesShort: ["sty", "lut", "mar", "kwi", "maj", "czec", "lip", "sie", "wrz", "paź", "lis", "gru"],
        showOtherMonths: true,
        onChangeMonthYear: function (year, month, picker) {
            get_events_for_month(year, month);
        },
        beforeShowDay: function (date) {
            var day_class = "";
            var day_tooltip = null;

            if (ppw_events_for_month !== null) {
                var date_string = toDateString(date);

                var event_titles = ppw_events_for_month[date_string];

                if (event_titles !== undefined) {
                    day_class = "ui-datepicker-has-event";
                    day_tooltip = event_titles.join("<br/>");
                }
            }

            if (toDateString(date) == ppw_date_start) {
                day_class = "ui-datepicker-current";
            }

            return [true, day_class, day_tooltip];
        },
    });
    var current_date = $(".ppw-calendar").datepicker("getDate");
    get_events_for_month(current_date.getFullYear(), current_date.getMonth() + 1);
});

})(jQuery);